export default __webpack_public_path__ + "static/media/darklogo.65d36c33.svg";